import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  const edgePoints = [
    { title: 'Trader Tough', desc: 'Built for the grind—real bulk, real savings, no fluff.' },
    { title: 'Stock Kings', desc: 'Piles of goods ready to shift—your warehouse away from home.' },
    { title: 'Nationwide Hustle', desc: 'From London to Lochs, we deliver the deals.' },
    { title: 'Price Smashers', desc: 'Cut costs, stack profits—wholesale done right.' },
  ];

  const bulkWins = [
    { label: 'Tonnes Moved', value: 1500, suffix: '+' },
    { label: 'Traders Backed', value: 800, suffix: '+' },
    { label: 'UK Zones Hit', value: 5, suffix: '+' },
    { label: 'Deals Locked', value: 200, suffix: '+' },
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2 className="about-title">About KKP Traders</h2>
        <div className="about-content">
          <h3>Bulk Hustle Unleashed</h3>
          <p>
            Launched in 2025, KKP Trade LTD is the new kid on the cash-and-carry block, tearing up Watford and beyond. We’re not here to mess about—we’re stacking pallets high with everything from energy drinks to bin bags, all priced to keep your margins fat. This is wholesale with guts, built for traders who live for the deal.
          </p>
        </div>
        <div className="edge-points">
          {edgePoints.map((point, index) => (
            <div key={index} className="edge-point">
              <h4 className="edge-title">{point.title}</h4>
              <p className="edge-desc">{point.desc}</p>
            </div>
          ))}
        </div>
        {/* <div className="bulk-wins">
          {bulkWins.map((win, index) => (
            <div key={index} className="win-item">
              <span className="win-value">{win.value}{win.suffix}</span>
              <span className="win-label">{win.label}</span>
            </div>
          ))}
        </div> */}
        <a href="#shop" className="about-cta">Shop Now</a>
      </div>
    </section>
  );
};

export default AboutSection;